import customAnalyticsApi from '../apis/customAnalytics.api';

export const unregisterSimulation = (
	dbid: string,
	analysisGroupId: string,
	simulationId: string,
) => {
	return customAnalyticsApi.post('unregister-simulations', {
		simulationInfo: { dbid, analysisGroupId, resultsetid: simulationId },
	});
};
